import React, { useState } from 'react';
import { useLocale } from '../../localization/LocaleContext';
import './PricingFAQ.css';

const faqKeys = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'];

export default function PricingFAQ() {
    const { t } = useLocale();
    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="pricing-faq sp-90">
            <div className="container">
                <h2 className="h-2 h-bold text-center mb-20">{t('pricingFaq.heading')}</h2>
                <p className="text-center mb-30" style={{ color: '#6b7280' }}>{t('pricingFaq.subheading')}</p>
                <div className="pricing-faq-list">
                    {faqKeys.map((key, index) => (
                        <div
                            className={`pricing-faq-item${openIndex === index ? ' pricing-faq-item--open' : ''}`}
                            key={key}
                        >
                            <button
                                className="pricing-faq-question"
                                onClick={() => toggle(index)}
                                aria-expanded={openIndex === index}
                            >
                                <span>{t(`pricingFaq.${key}.question`)}</span>
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="pricing-faq-chevron"
                                >
                                    <polyline points="6 9 12 15 18 9" />
                                </svg>
                            </button>
                            <div className="pricing-faq-answer">
                                <p>{t(`pricingFaq.${key}.answer`)}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
